export default function Arrow2({ className }) {
    return (
        <svg className={className} width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.6665 9.36573L21.6665 9.36573" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.73291 17.3983L1.66624 9.36627L9.73291 1.33293" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
